/**
 * 📦 매입 품목 고르기 창 (v2.304.0 · 개발요청 #16) — 판매물품 구입지급결의서의 줄마다.
 *
 *   사용자 10-26: 「구입지급결의서를 작성하는 중에 기존 품명 품목 그룹에서 선택하거나 새로 만들어서 특정해줘야
 *     매입관리에 등록이 원활히 될것 같아」.
 *   품목 목록·「+ 목록에 없음 — 직접 입력」은 매입 등록 창과 **같은 부품**(ItemPickerCombo)이다 — 규칙이 두 벌로 갈리지 않게.
 *   고르면 바로 닫히고 그 줄에 들어간다(저장은 결의서 [저장]·[상신] 때). 직접 입력한 품목은 최종승인 때 서버가 만든다.
 *
 * ⚠결의서 창(z-70) **안에** 그려야 그 위에 뜬다 — zIndex 80.
 */

import { DraggableModal } from './DraggableModal';
import { ItemPickerCombo, type PickerSelection } from './ItemPickerCombo';

export function ItemPickModal({ rowNo, description, onPick, onClose }: {
  /** 몇 번째 줄인가(1부터) — 제목에 */
  rowNo: number;
  /** 그 줄에 적은 품목 글 — 무엇을 고르는 중인지 보이게 */
  description: string;
  onPick: (sel: PickerSelection) => void;
  onClose: () => void;
}) {
  return (
    <DraggableModal onClose={onClose} initialWidth={560} initialHeight={460} zIndex={80} closeOnBackdrop={false} closeOnEsc={false}>
      <div className="dm-drag-handle flex items-center gap-2 border-b border-slate-200 bg-slate-50 px-4 py-2.5 cursor-move">
        <h3 className="ui-modal-title flex-1 truncate">📦 매입 품목 — {rowNo}행</h3>
        <button type="button" className="ui-close" onClick={onClose} aria-label="닫기">✕</button>
      </div>
      <div className="p-4 space-y-3 text-sm" data-item-pick-modal="">
        {description.trim() && (
          <p className="text-slate-600">
            결의서 품목: <b className="text-slate-800">{description.trim()}</b>
          </p>
        )}
        <p className="text-xs text-slate-500 leading-relaxed">
          이 물품이 <b>매입관리</b>에 들어갈 품목을 고르세요(품명·규격으로 검색). 목록에 없으면 맨 위
          <b> 「+ 목록에 없음 — 직접 입력」</b>으로 품목그룹·품명·규격을 적으면, 최종승인 때 새 품목으로 만들어집니다.
          품목을 고른 줄은 매입관리에 <b>「확인필요」 없이</b> 들어갑니다.
        </p>
        <ItemPickerCombo
          itemCode=""
          itemName=""
          onSelect={(sel) => onPick(sel)}
          onClear={() => { /* 고르는 창에서는 지울 것이 없다 */ }}
        />
        <div className="flex justify-end pt-1">
          <button type="button" className="btn btn-secondary" onClick={onClose}>취소</button>
        </div>
      </div>
    </DraggableModal>
  );
}
